import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './modules/loginModule/login/login.component';
import { ResetComponent } from './modules/loginModule/reset/reset.component';
import { SignupComponent } from './modules/loginModule/signup/signup.component';
import { DashboardComponent } from './modules/productModule/dashboard/dashboard.component';
import { authGuard } from './utils/auth.guard';
import { VerifyComponent } from './modules/loginModule/verify/verify.component';
import { AuthComponent } from './modules/loginModule/auth/auth.component';
import { MfaVerificationComponent } from './modules/loginModule/mfa-verification/mfa-verification.component';
import { CustomFirebaseComponent } from './modules/loginModule/custom-firebase/custom-firebase.component';

export const routes: Routes = [
  // , canActivate: [authGuard]
  {path: 'login', component: LoginComponent, canActivate: [authGuard]},
  {path: 'verify-mfa', component: MfaVerificationComponent, canActivate: [authGuard]},
  {path: 'verify-password', component: ResetComponent},
  {path: 'signup', component: SignupComponent, canActivate: [authGuard]},
  {path: 'verify', component: VerifyComponent},
  {path: '', component: DashboardComponent, canActivate: [authGuard], children: [
    // lazy-loaded product routes
    {path: 'products', loadComponent: () => import('./modules/productModule/products/products.component').then(m => m.ProductsComponent)},
    {path: 'pricing', loadComponent: () => import('./modules/productModule/pricing/pricing.component').then(m => m.PricingComponent)},
  ]},
  {path: 'auth', component: AuthComponent},
  // lazy-loaded MFA config routes
  {path: 'configure-mfa', loadComponent: () => import('./modules/productModule/config-mfa/config-mfa.component').then(m => m.ConfigMfaComponent), canActivate: [authGuard]},
  {path: 'unroll-mfa', loadComponent: () => import('./modules/productModule/unroll-mfa/unroll-mfa.component').then(m => m.UnrollMfaComponent)},
  {path: 'unenroll-mfa', loadComponent: () => import('./modules/productModule/unroll-mfa/unroll-mfa.component').then(m => m.UnrollMfaComponent)},
  {path: 'custom', component: CustomFirebaseComponent},
  {path: '**', redirectTo: '/login', pathMatch: 'full'},
//   {path: 'dashboard', loadChildren: ()=>import('./modules/productModule/products.module').then(m => m.ProductsModule)},
//   {path: '', loadChildren: ()=>import('./modules/productModule/products.module').then(m => m.ProductsModule)}
];
